import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import swal from "sweetalert";
import AdminHeader from "../../../header/admin_header";
import AdminSidebar from "../../../sidebar/admin_sidebar";
import { AssessmentService } from "../../../../_services/admin/assessmentService";
import "../../../Sector_Question_Manage/control.css";

const ViewAssessment = () => {
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();

  const [assessment, setAssessment] = useState(null);
  const [kpiCatalog, setKpiCatalog] = useState({});
  const [industryNames, setIndustryNames] = useState({});
  const [subIndustryNames, setSubIndustryNames] = useState({});
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const [aRes, kRes, iRes] = await Promise.all([
        AssessmentService.getAssessment(id),
        AssessmentService.listKpis(),
        AssessmentService.listIndustries(),
      ]);
      setLoading(false);
      if (aRes?.isSuccess) {
        setAssessment(aRes?.data?.data ?? null);
      }
      const catalogList = kRes?.data?.data ?? [];
      if (Array.isArray(catalogList)) {
        const map = {};
        catalogList.forEach((k) => {
          map[k.id] = k.title;
        });
        setKpiCatalog(map);
      }
      const industryList = iRes?.data?.data ?? iRes?.data ?? [];
      if (Array.isArray(industryList)) {
        const indMap = {};
        const subMap = {};
        industryList.forEach((row) => {
          indMap[row.industry_type_id] = row.industry_type_name;
          (row.items || []).forEach((sub) => {
            subMap[sub.id] = sub.title;
          });
        });
        setIndustryNames(indMap);
        setSubIndustryNames(subMap);
      }
    })();
  }, [id]);

  const isDraft = assessment?.status_key === "DRAFT";
  const isPublished = assessment?.status_key === "PUBLISHED";
  const canEdit = isDraft || isPublished;
  const canDelete = isDraft;

  const handleDelete = async () => {
    if (!assessment?.id) return;
    const confirmed = await swal({
      title: "Delete this draft template?",
      text: `"${assessment.title}" will be removed. This cannot be undone.`,
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });
    if (!confirmed) return;
    setDeleting(true);
    const res = await AssessmentService.deleteAssessment(assessment.id);
    setDeleting(false);
    if (res?.isSuccess || res?.status === 204) {
      await swal({ title: "Deleted", icon: "success" });
      history.push("/supplierassessment");
    } else {
      await swal({
        title: "Delete failed",
        text: res?.message || "Please try again.",
        icon: "error",
      });
    }
  };

  return (
    <div>
      <AdminSidebar dataFromParent={location.pathname} />
      <AdminHeader />
      <div className="main_wrapper">
        <div className="inner_wraapper">
          <div className="color_div_on framwork_2">
            <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
              <div className="heading">
                <h4 className="m-0">
                  <strong>
                    {assessment ? assessment.title : "Assessment"}
                  </strong>
                </h4>
              </div>
              <div>
                {canEdit && (
                  <button
                    type="button"
                    className="link_bal_next me-2"
                    onClick={() =>
                      history.push(`/supplierassessment/edit/${assessment.id}`)
                    }
                  >
                    <i className="far fa-edit me-1"></i> Edit
                  </button>
                )}
                {canDelete && (
                  <button
                    type="button"
                    className="link_bal_next_cancel me-2"
                    onClick={handleDelete}
                    disabled={deleting}
                    style={{
                      color: "#dc2626",
                      borderColor: "#dc2626",
                    }}
                  >
                    <i className="far fa-trash-alt me-1"></i>
                    {deleting ? "Deleting…" : "Delete"}
                  </button>
                )}
                <button
                  type="button"
                  className="link_bal_next_cancel"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
              </div>
            </div>

            {loading ? (
              <div className="text-center py-4 text-muted">Loading…</div>
            ) : !assessment ? (
              <div className="text-center py-4 text-muted">
                Assessment not found.
              </div>
            ) : (
              <>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <label className="form-label fw-semibold text-dark mb-1">
                      Status
                    </label>
                    <div>{assessment.status_key}</div>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label fw-semibold text-dark mb-1">
                      Industry
                    </label>
                    <div>
                      {industryNames[assessment.industry] ||
                        assessment.industry}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label fw-semibold text-dark mb-1">
                      Sub-industry
                    </label>
                    <div>
                      {subIndustryNames[assessment.sub_industry] ||
                        assessment.sub_industry}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label fw-semibold text-dark mb-1">
                      Updated
                    </label>
                    <div>{assessment.updated_at?.slice(0, 10)}</div>
                  </div>
                </div>

                {assessment.description && (
                  <div className="mb-3">
                    <label className="form-label fw-semibold text-dark mb-1">
                      Description
                    </label>
                    <div className="text-muted">{assessment.description}</div>
                  </div>
                )}

                {(() => {
                  const renderRow = (k, idx, isChild) => {
                    const effectiveWeightage =
                      k.weightage != null
                        ? k.weightage
                        : k.default_weightage != null
                        ? k.default_weightage
                        : null;
                    const isOverridden =
                      k.weightage_override != null &&
                      k.weightage_override !== k.default_weightage;
                    return (
                      <tr key={`${isChild ? "c" : "p"}-${k.kpi_id}`}>
                        <td>{isChild ? "" : idx + 1}</td>
                        <td style={{ paddingLeft: isChild ? 32 : undefined }}>
                          {isChild ? "↳ " : ""}
                          {k.kpi_title ||
                            kpiCatalog[k.kpi_id] ||
                            "(unknown KPI)"}
                        </td>
                        <td>{k.is_mandatory ? "Yes" : "No"}</td>
                        <td
                          title={
                            isOverridden
                              ? `Override (default: ${k.default_weightage ?? "—"})`
                              : "Default weightage"
                          }
                        >
                          {effectiveWeightage != null ? (
                            <span
                              style={{ fontWeight: isOverridden ? 700 : 400 }}
                            >
                              {effectiveWeightage}
                              {isOverridden ? "*" : ""}
                            </span>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>
                      </tr>
                    );
                  };
                  const total = (assessment.kpis || []).reduce(
                    (acc, k) =>
                      acc +
                      1 +
                      (Array.isArray(k.sub_kpis) ? k.sub_kpis.length : 0),
                    0
                  );
                  return (
                    <>
                      <div className="heading mt-4">
                        <h5 className="m-0">
                          <strong>KPIs ({total})</strong>
                        </h5>
                      </div>
                      <div className="table_f border-top mt-2 auto_scroll_by_design">
                        <Table striped bordered className="mt-2 mb-0">
                          <thead>
                            <tr className="heading_color sticky_header">
                              <th style={{ width: 50 }}>Sr.</th>
                              <th>KPI</th>
                              <th style={{ width: 140 }}>Mandatory</th>
                              <th style={{ width: 110 }}>Weightage</th>
                            </tr>
                          </thead>
                          {assessment.kpis && assessment.kpis.length > 0 ? (
                            <tbody>
                              {assessment.kpis.flatMap((parent, idx) => [
                                renderRow(parent, idx, false),
                                ...(Array.isArray(parent.sub_kpis)
                                  ? parent.sub_kpis.map((c) =>
                                      renderRow(c, idx, true)
                                    )
                                  : []),
                              ])}
                            </tbody>
                          ) : (
                            <tbody>
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-center text-muted py-4"
                                >
                                  No KPIs in this assessment.
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </Table>
                      </div>
                    </>
                  );
                })()}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAssessment;
